import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../../store";
import classes from "./EarTrainerSetup.module.css";

const EarTrainerIgnoreOctavesSelect = () => {
  const dispatch = useDispatch();
  const earTrainerIgnoreOctaves = useSelector(
    (state) => state.earTrainerIgnoreOctaves
  );
  const changeHandler = (event) => {
    dispatch(mainActions.setEarTrainerIgnoreOctaves(+event.target.value));
  };

  return (
    <tr>
      <td className={classes.td}>
        <select
          aria-label="Answer octave matching"
          value={earTrainerIgnoreOctaves}
          onChange={changeHandler}
          className={classes.select}
        >
          <option value="0">Exact pitch</option>
          <option value="1">Any octave</option>
        </select>
      </td>
      <td>Require the played octave, or accept any octave</td>
    </tr>
  );
};

export default EarTrainerIgnoreOctavesSelect;
